import Link from 'next/link'
import styled from 'styled-components'
import { MyImage } from '~/components/ui/MyImage'
import {
  getCompetitionList_marketingModule_competitionPage_edges_node,
  StartStatusEnum,
} from '~/graphqls/types'
import { toYMD } from '~/utils'

/** 大赛详情字段 */
export interface IAICompetitionContentObj {
  /**
   * pc-banner图
   */
  banner_pc: string | null
  /**
   * pc-活动介绍
   */
  desc_pc: string | null
  /**
   * h5-banner图
   */
  banner_h5: string | null
  /**
   * h5-活动介绍
   */
  desc_h5: string | null
  /**
   * 分享描述
   */
  share_txt: string | null
  /**
   * 分享图标
   */
  share_icon: string | null
  /**
   * 获奖公示（PC）
   */
  award_announcement_p_c: string | null
  /**
   * 获奖公示（H5）
   */
  award_announcement_h5: string | null
  /**
   * 主题
   *  */
  theme: string
  /**
   * 投稿须知
   *  */
  contributeNotice: string
  /**
   * 隐藏文案
   */
  hiddenText?: boolean
  /**
   * 简介banner pc link
   */
  desc_banner_link_pc?: string
  /**
   * 简介banner h5 link
   */
  desc_banner_link_h5?: string
  /**
   * 简介banner pc
   */
  desc_banner_pc?: string
  /**
   * 简介banner h5
   */
  desc_banner_h5?: string
}

/** 单个大赛详情 */
export interface IAICompetitionDetailNode
  extends getCompetitionList_marketingModule_competitionPage_edges_node,
    IAICompetitionContentObj {}

const StyledSingleCompetition = styled.div`
  margin-bottom: 32px;
  .competition-thumb-wrap {
    position: relative;
    height: 306px;
    border-radius: 16px;
    overflow: hidden;
    display: block;
    margin-bottom: 12px;
    &:hover {
      .competition-thumb {
        transform: scale(1.1);
        transition: all ease-in-out 180ms;
      }
    }
  }
  .competition-thumb {
    height: 100%;
    width: 100%;
    transition: all ease-in-out 180ms;
  }
  .competition-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .competition-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: ${props => props.theme['neutral-800']};
    margin-bottom: 4px;
  }
  .competition-date {
    font-size: 12px;
    line-height: 20px;
    color: ${props => props.theme['neutral-400']};
  }
  .competition-status {
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    img {
      vertical-align: middle;
      margin-right: 4px;
    }
    &--wait {
      background: linear-gradient(90deg, #2507cc 0%, #8e26d4 100%);
      color: #fff;
    }
    &--doing {
      background: ${props => props.theme.error};
      color: #fff;
    }
    &--end {
      background: ${props => props.theme['neutral-300']};
      color: ${props => props.theme['neutral-500']};
    }
  }
`

export const SingleCompetition: React.FC<{
  data: IAICompetitionDetailNode
}> = ({ data }) => {
  return (
    <StyledSingleCompetition>
      <Link href={`/ai-competition/${data.id}`}>
        <div className="competition-thumb-wrap">
          <MyImage
            tag="v800"
            className="competition-thumb"
            src={data.banner_pc}
          />
        </div>
      </Link>
      <div className="competition-info">
        <div className="w-[415px]">
          <Link href={`/ai-competition/${data.id}`}>
            <div className="competition-title line-clamp-1">{data.name}</div>
          </Link>
          <div className="competition-date">
            活动时间：{toYMD(data.startDateTime)} - {toYMD(data.endDateTime)}
          </div>
        </div>
        {data.startStatus === StartStatusEnum.WAIT && (
          <span className="competition-status competition-status--wait">
            <img src="/images/icons/hourglass-light.svg" alt="即将开始" />
            即将开始
          </span>
        )}
        {data.startStatus === StartStatusEnum.ING && (
          <span className="competition-status competition-status--doing">
            <img src="/images/icons/fire.svg" alt="进行中" />
            进行中
          </span>
        )}

        {data.startStatus === StartStatusEnum.END && (
          <span className="competition-status competition-status--end">
            <img src="/images/icons/hourglass-dark.svg" alt="已结束" />
            已结束
          </span>
        )}
      </div>
    </StyledSingleCompetition>
  )
}
